/**
 * Бридж к дизайн-системе платформы (`@aseller/antd-theme`).
 *
 * До этого модуля тема жила в самодельном `themeConfig.ts` — ручной копии того же
 * пакета: те же Rubik/14/16-16-8/30-40/sizeUnit 5, только переписанные литералами и
 * без тёмного режима. Копия и не могла его иметь: `darkAlgorithm` выводит цвета, а
 * половина интерфейса была покрашена hex'ами мимо токенов и в тёмной теме оставалась
 * светлой (сообщено с платформы 2026-08-21).
 *
 * Источник истины по значениям — токены ASeller DS, те же, что у платформы-хоста.
 * Поэтому модуль внутри платформы выглядит её частью, а не гостем со своей палитрой.
 *
 * Про `HostTheme` здесь намеренно ничего нет: слой `shared` не знает о слое `app`
 * (STRUCTURE.md), и перевод темы хоста в режим делает вызывающая сторона. Union'ы
 * совпадают, так что перевод — это присваивание, а не конверсия.
 */

import { getAntdTheme, type Mode } from '@aseller/antd-theme/antd';
import type { ThemeConfig } from 'antd';

/** Режим темы модуля: ровно то, чем его различает дизайн-система. */
export type ThemeMode = Mode;

/** Режим для standalone: своей страницей никто не управляет, тему задавать некому. */
export const STANDALONE_THEME_MODE: ThemeMode = 'light';

/**
 * `ThemeConfig` для `<ConfigProvider theme={...}>`.
 *
 * Оба режима используют один compact-алгоритм — размеры и отступы совпадают, поэтому
 * смена темы не сдвигает вёрстку; тёмный добавляет к нему `darkAlgorithm` только ради
 * цветов.
 */
export function appTheme(mode: ThemeMode): ThemeConfig {
  return getAntdTheme(mode);
}
